import { useSelector, useDispatch } from "react-redux";
import { fetchClinicians } from "../../redux/clinic/clinicSlice";
import { useCallback } from "react";
import { RootState } from '../../redux';
import { AppDispatch } from '../../redux';

const useFetchClinicians = () => {
  
  const dispatch = useDispatch<AppDispatch>();
  const clinicianState = useSelector((state: RootState) => state.clinics);

  const fetchClinicianData = useCallback(async () => {
    try {
      await dispatch(fetchClinicians()).unwrap();
    } catch (error) {
      console.error('Failed to fetch clinicians:', error);
    }
  }, [dispatch]);

  return { ...clinicianState, fetchClinicianData };
};

export default useFetchClinicians;
